import * as Yup from 'yup';

import { Place } from '@barboxx/models';
import {
    DEFAULT_HOURS_OF_OPERATIONS,
    HoursOfOperation,
    HoursOfOperations,
    MEDIUM_TEXT,
    MINIMUM_TEXT,
    PHONE_REGEX,
    PLACE_CATEGORY_TYPES,
    PlaceCategoryTypes,
    TINY_TEXT,
    ZIP_CODE_REGEX,
} from '@barboxx/types';
import { enumToList, StatesHash, transformEmptyToNull } from '@barboxx/utils';

export const HOURS_OF_OPERATION_SCHEMA = Yup.object<HoursOfOperation>()
    .default(null)
    .shape({
        open: Yup.string().required(),
        close: Yup.string().required(),
    })
    .transform(value => {
        // Generated by Copilot
        if (!value) {
            return null;
        }

        if (
            (value.open == null || value.open === '') &&
            (value.close == null || value.close === '')
        ) {
            return null;
        }

        return value;
    })

    .nullable();

export const HOURS_OF_OPERATIONS_SCHEMA = Yup.object<HoursOfOperations>().shape(
    {
        monday: HOURS_OF_OPERATION_SCHEMA,
        tuesday: HOURS_OF_OPERATION_SCHEMA,
        wednesday: HOURS_OF_OPERATION_SCHEMA,
        thursday: HOURS_OF_OPERATION_SCHEMA,
        friday: HOURS_OF_OPERATION_SCHEMA,
        saturday: HOURS_OF_OPERATION_SCHEMA,
        sunday: HOURS_OF_OPERATION_SCHEMA,
    }
);

export const PLACE_SCHEMA = Yup.object<Place.UpdateRequest>().shape({
    id: Yup.string().required(),
    name: Yup.string()
        .min(MINIMUM_TEXT, 'Too Short!')
        .max(TINY_TEXT, 'Too Long!')
        .required(),
    description: Yup.string()
        .min(MINIMUM_TEXT, 'Too Short!')
        .max(MEDIUM_TEXT, 'Too Long!')
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    streetAddress: Yup.string()
        .min(4, 'Too Short!')
        .max(250, 'Too Long!')
        .required(),
    city: Yup.string()
        .min(MINIMUM_TEXT, 'Too Short!')
        .max(100, 'Too Long!')
        .required(),
    zip: Yup.string()
        .matches(ZIP_CODE_REGEX, 'Should match a zip code')
        .required(),
    latitude: Yup.number()
        .max(90)
        .min(-90)
        .transform(value => Number(value))
        .required(),
    longitude: Yup.number()
        .max(180)
        .min(-180)
        .transform(value => Number(value))
        .required(),
    state: Yup.string()
        .oneOf(Object.keys(StatesHash), 'must match type of place category')
        .required(),
    category: Yup.string()
        .oneOf<PlaceCategoryTypes>(
            enumToList(PLACE_CATEGORY_TYPES),
            'must match type of place category'
        )
        .required(),
    mainImage: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    website: Yup.string()
        .url()
        .nullable()
        .transform(transformEmptyToNull)
        .default(null),
    phoneNumber: Yup.string()
        .nullable()
        .transform(transformEmptyToNull)
        .matches(PHONE_REGEX, 'Must be a phone number'),
    enabled: Yup.boolean().default(true),
    hoursOfOperations: HOURS_OF_OPERATIONS_SCHEMA.default(
        DEFAULT_HOURS_OF_OPERATIONS
    ).required(),
});

export const CREATE_PLACE_SCHEMA = PLACE_SCHEMA.omit(['id']);
